
import React, { Component } from 'react';
import { publicUrl } from '../../client/utils';


export default class Testimonial extends Component {

  render() {

    const {
      id,
      name,
      title,
      company,
      url,
      quote,
    } = this.props;

    return (
      <div className="testimonial">
        <img src={publicUrl(`/media/img/testimonials/${id}-avatar.jpg`)} alt={name} />
        <div className="testimonial__person">
          {name}, {title}
        </div>
        <a target="_blank" rel="noopener noreferrer nofollow" href={url}>
          {company}
        </a>
        <div className="testimonial__quote">
          "{quote}"
        </div>
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./client/components/Testimonial.jsx